import { render, staticRenderFns } from "./DistributorDetailsPage.vue?vue&type=template&id=2ad99ef6&"
import script from "./DistributorDetailsPage.vue?vue&type=script&lang=js&"
export * from "./DistributorDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports